export default __webpack_public_path__ + "static/media/DJ.dbba3a50.jpg";